import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { CoachSettingsPage } from 'pages/coach-settings/coach-settings';

@NgModule({
  declarations: [CoachSettingsPage],
  imports: [PagesModule, ComponentsModule],
  exports: [CoachSettingsPage],
})
export class CoachSettingsPageModule {}
